import { Component, inject } from '@angular/core'

import { MatIconModule } from '@angular/material/icon'
import { AuthService } from '../../services/auth.service'

@Component({
  selector: 'traction-login',
  imports: [MatIconModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent {
  authService = inject(AuthService)
}
